import { z } from 'zod';

import { updatePlayerPayloadSchema } from './update-player-payload';

export type UpdatePlayersPayload = z.output<typeof updatePlayersPayloadSchema>;
export type UpdatePlayersPayloadDTO = z.input<typeof updatePlayersPayloadSchema>;

export const updatePlayersPayloadSchema = z.array(
  updatePlayerPayloadSchema.extend({ id: z.uuid() }),
);
